// imageLoader.js — lazy dynamic image loading with in-memory cache.
// Adapted for Shoval's flat src/images folder with `.webp` files
// named `{folderName} {index}.webp`.

const imageCache = new Map();

export const loadSingleImage = async (folderName, index) => {
  const cacheKey = `${folderName}-${index}`;

  if (imageCache.has(cacheKey)) {
    return imageCache.get(cacheKey);
  }

  try {
    const mod = await import(`../images/${folderName} ${index}.webp`);
    const url = mod.default;
    imageCache.set(cacheKey, url);
    return url;
  } catch (err) {
    try {
      const mod = await import(`../images/${folderName} ${index}.jpg`);
      const url = mod.default;
      imageCache.set(cacheKey, url);
      return url;
    } catch (err2) {
      console.error(`Failed to load image: ${folderName} ${index}`, err2);
      return null;
    }
  }
};

export const loadThumbnail = async (folderName, thumbnailIndex) => {
  return loadSingleImage(folderName, thumbnailIndex);
};

export const loadProjectGallery = async (folderName, count) => {
  const promises = Array.from({ length: count }, (_, i) =>
    loadSingleImage(folderName, i + 1)
  );
  const images = await Promise.all(promises);
  return images.filter(Boolean);
};

export const clearImageCache = () => imageCache.clear();
